export default __webpack_public_path__ + "static/media/design.4c4f9978.svg";